class SectionSpecifications extends HTMLElement {
  constructor() {
    super();
    this.carousel = this.querySelector('[data-specs-carousel');

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;
      this.initFunction();
    });
  }

  initFunction() {
    if (!this.carousel) return;

    const { Swiper } = this.swiperLib;

    this.swiper = new Swiper(this.carousel, {
      slidesPerView: 'auto',
      spaceBetween: 40,
      direction: "horizontal",
      loop: false,
      touchEventsTarget: 'container',
      slideToClickedSlide: true,
      freeMode: {
        enabled: true,
        sticky: true
      }
    });
  }
}

if (!customElements.get("section-specifications")) {
  customElements.define("section-specifications", SectionSpecifications);
}
